/**
 * sortFilterRules - returns a sorted list of filterRules in the following order:
 * FILTER_URGENCY > FILTER_GENRE > FILTER_CATEGORY > FILTER_FULLTEXT > FILTER_AREA
 */
export default filterRules => {
  const urgency = filterRules.filter(({ type }) => type === "FILTER_URGENCY");
  const isFavorite = filterRules.filter(
    ({ type }) => type === "FILTER_IS_FAVORITE"
  );
  const genre = filterRules.filter(({ type }) => type === "FILTER_GENRE");
  const itemclass = filterRules.filter(
    ({ type }) => type === "FILTER_ITEMCLASS"
  );
  const ressort = filterRules.filter(({ type }) => type === "FILTER_CATEGORY");
  const fulltext = filterRules.filter(({ type }) => type === "FILTER_FULLTEXT");
  const area = filterRules.filter(({ type }) => type === "FILTER_AREA");

  return [
    ...urgency,
    ...isFavorite,
    ...genre,
    ...itemclass,
    ...ressort,
    ...fulltext,
    ...area
  ].map(rule => ({
    type: rule.type,
    values: rule.values,
    // NB: Not sending 'exclude' to API if rule.exclude is false
    ...(!!rule.exclude && rule.exclude === true ? { exclude: true } : {})
  }));
};
